import { services } from "../config/services";
import { customFetch } from "../customFetch";

export enum EndpointsCountProperty {
  Location = "Location",
  OperatingSystem = "OperatingSystem",
  AggerVersion = "AggerVersion",
}

export enum CountPeriod {
  AllTime = "AllTime",
  Last7Days = "Last7Days",
}

export const dashboard = {
  getDailyIncidents: (companyId: string) =>
    customFetch(`${services.stats}/daily-incidents?CompanyId=${companyId}`),
  getEndpointsCount: (companyId: string) =>
    customFetch(`${services.stats}/endpoints-count?CompanyId=${companyId}`),
  getIncidentsCount: (companyId: string) =>
    customFetch(`${services.stats}/incidents-count?CompanyId=${companyId}`),
  getEndpointsCountByProperty: (
    companyId: string,
    property: EndpointsCountProperty,
    period: CountPeriod = CountPeriod.AllTime,
  ) =>
    customFetch(
      `${services.stats}/endpoints-count-by-property?CompanyId=${companyId}&Property=${property}&Period=${period}`,
    ),
};
